import { Tabs, TabsProps, Tab, TabProps, ThemeOptions } from '@mui/material'

export type { TabsProps, TabProps }

export { Tabs, Tab }

export const tabsThemeOverrides: ThemeOptions['components'] = {
  MuiTab: {
    styleOverrides: {
      root: {
        padding: '9px 16px',
        textTransform: 'none',
        fontSize: 14,
        lineHeight: 1.5,
        fontWeight: 600,
      },
    },
  },
}
